export enum UserType {
    PARTIAL,
    COMPLETE
}
